/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */

import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	databaseTemplateType: {
		id: 'experiment-personalized-templates-v2.database.template',
		defaultMessage: 'Database template',
		description: 'Subheading on a card if the template suggestion is for database content type',
	},
	getStartedHeader: {
		id: 'experiment-personalized-templates-v2.getting.started.header',
		defaultMessage: 'Get started',
		description: 'Heading for the onboarding takeover cards.',
	},
	simpleRetrospectiveTemplate: {
		id: 'experiment-personalized-templates-v2.simple.retrospective.template',
		defaultMessage: 'Simple retrospective',
		description: 'Whiteboard template title',
	},
	flowchartTemplate: {
		id: 'experiment-personalized-templates-v2.flowchart.template',
		defaultMessage: 'Flowchart',
		description: 'Whiteboard template title',
	},
	prioritizationMatrixTemplate: {
		id: 'experiment-personalized-templates-v2.prioritization.matrix.template',
		defaultMessage: 'Prioritization matrix',
		description: 'Whiteboard template title',
	},
	brainwritingTemplate: {
		id: 'experiment-personalized-templates-v2.brainwriting.template',
		defaultMessage: 'Brainwriting',
		description: 'Whiteboard template title',
	},
	incidentPostmortemTemplate: {
		id: 'experiment-personalized-templates-v2.incident.postmortem.template',
		defaultMessage: 'Incident postmortem',
		description: 'Whiteboard template title',
	},
	fourLsTemplate: {
		id: 'experiment-personalized-templates-v2.four.ls.template',
		defaultMessage: '4 Ls Retro',
		description: 'Whiteboard template title',
	},
	networkOfTeamsTemplate: {
		id: 'experiment-personalized-templates-v2.network.of.teams.template',
		defaultMessage: 'Network of teams',
		description: 'Whiteboard template title',
	},
	disruptiveBrainstormTemplate: {
		id: 'experiment-personalized-templates-v2.disruptive.brainstorm.template',
		defaultMessage: 'Disruptive brainstorm',
		description: 'Whiteboard template title',
	},
	conceptMapTemplate: {
		id: 'experiment-personalized-templates-v2.concept.map.template',
		defaultMessage: 'Concept map',
		description: 'Whiteboard template title',
	},
	swimlanesProcessMapTemplate: {
		id: 'experiment-personalized-templates-v2.swimlanes.process.map.template',
		defaultMessage: 'Swimlanes process map',
		description: 'Whiteboard template title',
	},
	swotAnalysisTemplate: {
		id: 'experiment-personalized-templates-v2.swot.analysis.template',
		defaultMessage: 'SWOT Analysis',
		description: 'Whiteboard template title',
	},
	focusAreaDiagramTemplate: {
		id: 'experiment-personalized-templates-v2.focus.area.diagram.template',
		defaultMessage: 'Focus area diagram',
		description: 'Whiteboard template title',
	},
	userStoryMapTemplate: {
		id: 'experiment-personalized-templates-v2.user.story.map.template',
		defaultMessage: 'User story map',
		description: 'Whiteboard template title',
	},
	fishboneDiagramTemplate: {
		id: 'experiment-personalized-templates-v2.fishbone.diagram.template',
		defaultMessage: 'Fishbone diagram',
		description: 'Whiteboard template title',
	},
	orgChartTemplate: {
		id: 'experiment-personalized-templates-v2.org.chart.template',
		defaultMessage: 'Org chart',
		description: 'Whiteboard template title',
	},
	icebreakersTemplate: {
		id: 'experiment-personalized-templates-v2.icebreakers.template',
		defaultMessage: 'Icebreakers',
		description: 'Whiteboard template title',
	},
	serviceBlueprintTemplate: {
		id: 'experiment-personalized-templates-v2.service.blueprint.template',
		defaultMessage: 'Service blueprint',
		description: 'Whiteboard template title',
	},
	productVisionTemplate: {
		id: 'experiment-personalized-templates-v2.product.vision.board.template',
		defaultMessage: 'Product vision board',
		description: 'Whiteboard template title',
	},
	workflowTemplate: {
		id: 'experiment-personalized-templates-v2.workflow.template',
		defaultMessage: 'Workflow',
		description: 'Whiteboard template title',
	},
	timelineWorkflowTemplate: {
		id: 'experiment-personalized-templates-v2.timeline.workflow.template',
		defaultMessage: 'Timeline workflow',
		description: 'Whiteboard template title',
	},
	teamHealthMonitorTemplate: {
		id: 'experiment-personalized-templates-v2.team.health.monitor.template',
		defaultMessage: 'Team health monitor',
		description: 'Whiteboard template title',
	},
	teamCharterTemplate: {
		id: 'experiment-personalized-templates-v2.team.charter.template',
		defaultMessage: 'Team charter template',
		description: 'Whiteboard template title',
	},
	actionPlanTemplate: {
		id: 'experiment-personalized-templates-v2.action.plan.template',
		defaultMessage: 'Action plan',
		description: 'Whiteboard template title',
	},
	gapAnalysisTemplate: {
		id: 'experiment-personalized-templates-v2.gap.analysis.template',
		defaultMessage: 'Gap analysis',
		description: 'Whiteboard template title',
	},
	productRoadmapTemplate: {
		id: 'experiment-personalized-templates-v2.product.roadmap.template',
		defaultMessage: 'Product roadmap',
		description: 'Whiteboard template title',
	},
	crazy8sBrainstormingTemplate: {
		id: 'experiment-personalized-templates-v2.product.crazy-8s-brainstorming.template',
		defaultMessage: 'Crazy 8s brainstorming',
		description: 'Whiteboard template title',
	},
	annualCalendarTemplate: {
		id: 'experiment-personalized-templates-v2.product.annual-calendar.template',
		defaultMessage: 'Annual Calendar',
		description: 'Whiteboard template title',
	},
	stakeholderMappingTemplate: {
		id: 'experiment-personalized-templates-v2.product.stakeholder-mapping.template',
		defaultMessage: 'Stakeholder mapping',
		description: 'Whiteboard template title',
	},
	rootCauseTemplate: {
		id: 'experiment-personalized-templates-v2.product.root-cause.template',
		defaultMessage: 'Root cause analysis',
		description: 'Whiteboard template title',
	},
	executiveSummaryTemplate: {
		id: 'experiment-personalized-templates-v2.product.executive-summary.template',
		defaultMessage: 'Executive summary',
		description: 'Whiteboard template title',
	},
	elevatorPitchTemplate: {
		id: 'experiment-personalized-templates-v2.product.elevator-pitch.template',
		defaultMessage: 'Elevator pitch',
		description: 'Whiteboard template title',
	},
});
